import { Map as ImmutableMap } from 'immutable';
import * as ChartTypes from 'reporting-data/constants/chartTypes';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { gate } from 'hub-http/gates';
import { getReportChartType } from 'reporting-data/report/reportGetters';
const SLICED_MIGRATION_GATE = gate('ReportingViz:UnifiedSlicedSOMigration');
const canMigrate = (report, gates) => {
  var _gates$includes;
  const chartType = getReportChartType(report);
  const isCompatibleChartType = [ChartTypes.PIE, ChartTypes.DONUT].includes(chartType);
  const isUngated = (_gates$includes = gates === null || gates === void 0 ? void 0 : gates.includes(SLICED_MIGRATION_GATE)) !== null && _gates$includes !== void 0 ? _gates$includes : false;
  return isUngated && isConfigReport(report) && isCompatibleChartType;
};

/**
 * Transformation Rules:
 * 1. Set `chartType` to `chartType`.
 * 2. Set `style` to `displayParams.showTotals` and `displayParams.legendPosition`.
 * 3. Interpret `displayParams.hideDataLabels` and set `style.dataLabels` to its inverse, or undefined if not present.
 * 4. Set `color` to `displayParams.colors`.
 * 5. Delete `displayParams.showTotals`, `displayParams.hideDataLabels`, and `displayParams.legendPosition`.
 * 6. Delete `displayParams.colors`.
 */
const migrate = (reportInput, gates) => {
  if (!isConfigReport(reportInput) || !canMigrate(reportInput, gates)) {
    return reportInput;
  }
  const migratedReport = reportInput.withMutations(map => {
    const chartType = map.get('chartType');
    const displayParams = map.get('displayParams') || ImmutableMap();
    const colors = displayParams.get('colors');
    const dataLabels = displayParams.has('hideDataLabels') ? !displayParams.get('hideDataLabels') : undefined;
    const chart = ImmutableMap({
      chartType,
      style: ImmutableMap({
        showTotals: displayParams.get('showTotals'),
        dataLabels,
        legendPosition: displayParams.get('legendPosition')
      }),
      color: colors
    });
    return map.set('chart', chart).deleteIn(['displayParams', 'showTotals']).deleteIn(['displayParams', 'hideDataLabels']).deleteIn(['displayParams', 'legendPosition']).deleteIn(['displayParams', 'colors']);
  });
  return migratedReport;
};
export const ConfigSlicedMigration = {
  canMigrate,
  migrate
};
export const __TESTABLE__ = {
  SLICED_MIGRATION_GATE
};